<lib-base-signal-input
  [label]="label()"
  [hint]="description()"
  [showRequired]="showRequiredIndicator()"
  [showError]="displayError()"
  [errorMessage]="displayMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
  [inputId]="inputId()">
  <div input #fieldRoot [class]="shellClasses()" class="mt-2">
    <button
      #currencyButton
      type="button"
      class="flex h-full shrink-0 items-center gap-1.5 border-r border-gray-200 bg-gray-50 px-3 text-sm whitespace-nowrap text-gray-700 transition-colors duration-200 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
      [class.cursor-pointer]="canChangeCurrency()"
      [class.hover:bg-gray-100]="canChangeCurrency()"
      [class.cursor-default]="!canChangeCurrency()"
      [class.text-blue-600]="isPickerOpen() && !displayError() && !disabled()"
      [id]="currencyButtonId()"
      [disabled]="disabled()"
      [attr.aria-disabled]="!canChangeCurrency() || null"
      [attr.aria-label]="'Currency, ' + (selectedCurrency()?.name ?? currencyType())"
      [attr.aria-haspopup]="canChangeCurrency() ? 'listbox' : null"
      [attr.aria-expanded]="canChangeCurrency() ? isPickerOpen() : null"
      [attr.aria-controls]="canChangeCurrency() ? panelId() : null"
      (click)="togglePicker()"
      (focus)="onAmountFocus()"
      (blur)="onAmountBlur($event)"
      (keydown)="onCurrencyButtonKeyDown($event)">
      @if (selectedCurrency(); as currency) {
        @if (currency.flag) {
          <span class="text-base leading-none" aria-hidden="true">{{ currency.flag }}</span>
        }
        <span>{{ currency.code }}</span>
      } @else {
        <span>{{ currencyType() }}</span>
      }
      @if (allowChangeCurrency() && !disabled() && !readonly()) {
        <svg
          class="h-5 w-5 transition-transform duration-200"
          [class.rotate-180]="isPickerOpen()"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true">
          <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
        </svg>
      }
    </button>

    <input
      #inputRef
      class="h-full min-w-0 flex-1 border-0 bg-transparent px-3 text-sm outline-none placeholder:text-gray-400 disabled:cursor-not-allowed disabled:text-gray-400"
      [class.text-gray-900]="!disabled() && amountText().trim()"
      [class.text-gray-800]="!disabled() && !amountText().trim()"
      type="text"
      inputmode="decimal"
      autocomplete="off"
      [id]="inputId()"
      [placeholder]="placeholder()"
      [value]="amountText()"
      [disabled]="disabled()"
      [readOnly]="readonly()"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.aria-invalid]="displayError() || null"
      [attr.aria-required]="showRequiredIndicator() || null"
      (input)="updateAmount($event)"
      (focus)="onAmountFocus()"
      (blur)="onAmountBlur($event)"
      (keydown)="onAmountKeyDown($event)" />

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="currencyButton"
      [cdkConnectedOverlayOpen]="isPickerOpen()"
      (overlayOutsideClick)="closePicker()"
      [cdkConnectedOverlayBackdropClass]="['bg-black', 'bg-opacity-20']"
      [cdkConnectedOverlayPositions]="[
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
        { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' }
      ]"
      [cdkConnectedOverlayScrollStrategy]="repositionScrollStrategy"
      [cdkConnectedOverlayOffsetY]="10">
      <app-currency-picker-panel
        [panelId]="panelId()"
        [currencies]="currencies()"
        [selectedCurrency]="selectedCurrency()"
        [panelWidth]="panelWidth()"
        [listboxLabelledBy]="currencyButtonId()"
        (currencySelected)="onCurrencySelected($event)"
        (dismissed)="closePicker()" />
    </ng-template>
  </div>
</lib-base-signal-input>
